/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import client from "./client";

/**
 * Team folders. A team-owned folder belongs to the team rather than to whoever
 * created it, so it survives that person leaving — which is the difference
 * between this and sharing a personal folder with the organisation.
 *
 * Teams are scoped to the organisation the session is acting as, so switching
 * organisation changes which teams appear.
 */
export const listMyTeams = async () => {
  const { data } = await client.get("/drive/teams");
  return data.teams || [];
};

export const getTeam = async (id) => {
  const { data } = await client.get(`/drive/teams/${id}`);
  return {
    role: data.role,
    teamName: data.team_name,
    description: data.description,
    folders: data.folders || [],
  };
};

export const createTeam = async ({ teamName, description }) => {
  const { data } = await client.post("/drive/teams", {
    team_name: teamName,
    description,
  });
  return data.team;
};

export const updateTeam = async (id, { teamName, description } = {}) => {
  const { data } = await client.patch(`/drive/teams/${id}`, {
    team_name: teamName,
    description,
  });
  return data.team;
};

export const deleteTeam = async (id) => {
  const { data } = await client.delete(`/drive/teams/${id}`);
  return data.team;
};

export const listMembers = async (id) => {
  const { data } = await client.get(`/drive/teams/${id}/members`);
  return data.members || [];
};

/** Resolve an email to a user within this team's organisation, for "add by email". */
export const lookupMember = async (id, email) => {
  const { data } = await client.get(`/drive/teams/${id}/members/lookup`, { params: { email } });
  return data.user;
};

export const addMember = async (id, { userId, role = "member" }) => {
  const { data } = await client.post(`/drive/teams/${id}/members`, {
    user_id: userId,
    role,
  });
  return data.member;
};

export const removeMember = async (id, memberUserId) => {
  const { data } = await client.delete(`/drive/teams/${id}/members/${memberUserId}`);
  return data.member;
};

export const setMemberRole = async (id, memberUserId, role) => {
  const { data } = await client.patch(`/drive/teams/${id}/members/${memberUserId}/role`, null, { params: { role } });
  return data.member;
};
